// extracted by mini-css-extract-plugin
export var saHomeBoxesSection = "saBoxes2-module--saHomeBoxesSection--1aB0q";
export var saBoxesTitleContainer = "saBoxes2-module--saBoxesTitleContainer--3zFRv";
export var saBoxesTextContainer = "saBoxes2-module--saBoxesTextContainer--1HR6A";
export var saBoxesBlocks = "saBoxes2-module--saBoxesBlocks--2Drbg";
export var saBoxesBlocksItem = "saBoxes2-module--saBoxesBlocksItem--1KlSX";
export var saBoxesBlocksItemIcon = "saBoxes2-module--saBoxesBlocksItemIcon--r69iw";
export var saBoxesBlocksItemTitle = "saBoxes2-module--saBoxesBlocksItemTitle--2Nqst";
export var saBoxesBlocksItemText = "saBoxes2-module--saBoxesBlocksItemText--Mvd6n";
export var saBoxesTitle = "saBoxes2-module--saBoxesTitle--2Fgsq";